function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStoreMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.78 130.42",
    height: 28,
    width: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.78,130.42a16.33,16.33,0,0,1-7.94-2.07L8.36,104.65A16.3,16.3,0,0,1,0,90.42V37.22a11.57,11.57,0,0,1,5.93-10.1L50.84,2.06a16.33,16.33,0,0,1,15.88,0l42.48,23.6c5.77,3.27,8.35,7.66,8.35,14.24V90.42a16.3,16.3,0,0,1-8.36,14.23l-42.47,23.7A16.35,16.35,0,0,1,58.78,130.42Z",
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.86,10a10.4,10.4,0,0,0-10.17,0L8.27,35.3V89a10.46,10.46,0,0,0,5.35,9.12l40.07,22.35a10.45,10.45,0,0,0,10.17,0l40.07-22.35A10.45,10.45,0,0,0,109.29,89V35.3Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,66.16a15.94,15.94,0,0,1-7.76-2l-42.94-24a4.35,4.35,0,1,1,4.23-7.6l43,24a7.11,7.11,0,0,0,7,0l43-24a4.33,4.33,0,0,1,5.92,1.68,4.36,4.36,0,0,1-1.68,5.91l-43,24A15.93,15.93,0,0,1,58.77,66.16Z",
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.77,111.55,74,122.56V90.73a5.66,5.66,0,0,1,2.9-4.94l13.34-7.44a2.34,2.34,0,0,1,3.49,2Z",
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.51,124.05,15.24,104.39V60a2.61,2.61,0,0,1,3.91-2.26L46.08,73.15a6.87,6.87,0,0,1,3.43,5.94Z",
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6,86,22,74V69.64a1.16,1.16,0,0,1,1.74-1L41.05,78.82A3.08,3.08,0,0,1,42.6,81.5Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6,100.69,22,88.62V84.29a1.16,1.16,0,0,1,1.74-1L41.05,93.47a3.08,3.08,0,0,1,1.55,2.68Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6,114.55,22,102.48V98.16a1.16,1.16,0,0,1,1.74-1l17.35,10.17A3.11,3.11,0,0,1,42.6,110Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,78.79a6.91,6.91,0,0,0,3.47-.93l48.38-27.92a10,10,0,0,0,5-8.63V12.76a7.53,7.53,0,0,0-11.3-6.52L69.68,34a10,10,0,0,0-5,8.63L65,71.86A6.92,6.92,0,0,0,72,78.79Z",
    style: {
      fill: "#003173"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreMap);
export default __webpack_public_path__ + "static/media/store_map.bcfab7c7607c7f89713ca55067aeca46.svg";
export { ForwardRef as ReactComponent };